import React from 'react'
import { listMonitoresAtivos } from '../services/monitoringService'
import type { MonitorItem } from '../types-monitor'

export function useMonitoring() {
  const [items, setItems] = React.useState<MonitorItem[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    setLoading(true); setError(null)
    try {
      const rows = await listMonitoresAtivos()
      // Mostrar apenas uma oportunidade por moeda (símbolo)
      // Como o serviço já retorna ordenado por `updated_at` desc,
      // mantemos o primeiro item de cada símbolo (o mais recente).
      const seen = new Set<string>()
      const unique: MonitorItem[] = []
      for (const it of rows) {
        const sym = String(it.symbol || '').toUpperCase()
        if (!seen.has(sym)) {
          seen.add(sym)
          unique.push(it)
        }
      }
      setItems(unique)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar monitores')
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => { load() }, [load])

  return { items, loading, error, reload: load }
}
